/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDRequestMetadata } from './IDRequestMetadata';
import {
    IDRequestMetadataFromJSON,
    IDRequestMetadataFromJSONTyped,
    IDRequestMetadataToJSON,
    IDRequestMetadataToJSONTyped,
} from './IDRequestMetadata';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
    FactorToJSONTyped,
} from './Factor';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface IDRequestV2
 */
export interface IDRequestV2 {
    /**
     * 
     * @type {PersonHandle}
     * @memberof IDRequestV2
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {Factor}
     * @memberof IDRequestV2
     */
    factor?: Factor;
    /**
     * 
     * @type {IDRequestMetadata}
     * @memberof IDRequestV2
     */
    metadata?: IDRequestMetadata;
}

/**
 * Check if a given object implements the IDRequestV2 interface.
 */
export function instanceOfIDRequestV2(value: object): value is IDRequestV2 {
    return true;
}

export function IDRequestV2FromJSON(json: any): IDRequestV2 {
    return IDRequestV2FromJSONTyped(json, false);
}

export function IDRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'] == null ? undefined : PersonHandleFromJSON(json['handle']),
        'factor': json['factor'] == null ? undefined : FactorFromJSON(json['factor']),
        'metadata': json['metadata'] == null ? undefined : IDRequestMetadataFromJSON(json['metadata']),
    };
}

export function IDRequestV2ToJSON(json: any): IDRequestV2 {
    return IDRequestV2ToJSONTyped(json, false);
}

export function IDRequestV2ToJSONTyped(value?: IDRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': PersonHandleToJSON(value['handle']),
        'factor': FactorToJSON(value['factor']),
        'metadata': IDRequestMetadataToJSON(value['metadata']),
    };
}

